import React, { useEffect, useState } from "react";
import { MdMenu } from "react-icons/md";
import { Route, Routes } from "react-router-dom";
import navContext from "../Context/navContext";
import Header from "./Components/Header/Header";
import Nav from "../Nav/Nav";

import logo from "../../assets/logo.svg";
import DashBoardMain from "./Components/DashBoardMain/DashBoardMain";
import ListDocumentForOneSalarie from "./Components/ListDocumentForOneSalarie/ListDocumentForOneSalarie";
import { getTokenData } from "../../services/Auth__Service";
import { findOne } from "../../services/Salarie__Service";
import { Fragment } from "react";
import Loader from "../Loader/Loader";
import { PROFIL_USER } from "../../services/config";
import Profil from "./Components/Profil/Profil";
import { getSalariePhoto } from "../../services/Fonction__Services";
import Notifications from "../Notifications/Notifications";
import Folder from "./Components/Folder/Folder";
import ListFile from "./Components/File/File";
import UserInfos from "../UserInfos/UserInfos";

const Salaries = () => {
  const [imgProfile, setImgProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [salarieId, setSalrieId] = useState(0);
  const [salarie, setSalarie] = useState(null);
  const [profil, setProfil] = useState({
    id: 0,
    name: "",
  });

  const [nav, setNav] = useState({
    links: [
      {
        href: "/salarie/dashboard",
        linkname: "Accueil",
      },
    ],
    children: "",
  });
  const navFunction = (value) => {
    setNav({ ...value });
  };

  const showHeader = () => {
    document.querySelector(".header").classList.add("show");
  };

  useEffect(() => {
    const data = getTokenData();
    const profil = PROFIL_USER.find((elt) => {
      return parseInt(elt.profil) === parseInt(data.profil);
    });

    setProfil((value) => {
      return {
        ...value,
        id: data.profil,
        name: profil !== undefined ? profil.profilName : "",
      };
    });
    setSalrieId(data.user_id);
    fetchOnesalarie(data.user_id);
  }, []);

  const fetchOnesalarie = async (id) => {
    findOne(id)
      .then((response) => {
        setSalarie(response.data);
        if (response.data.photo === "null") {
          setIsLoading(false);
        } else {
          fecthFile(response.data.photo);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const fecthFile = async (filname) => {
    getSalariePhoto(filname)
      .then((response) => {
        setImgProfile(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <Fragment>
      <div className="main">
        <navContext.Provider value={navFunction}>
          <Header />
          <div className="content">
            <div className="header-responsive">
              <div className="menu-btn" onClick={showHeader}>
                <MdMenu size="40px" />
              </div>
              <img src={logo} alt="logo" className="header-responsive__logo" />
            </div>
            <div className="header__top">
              <div className="header__icons">
                <div className="header__icon">
                  <Notifications />
                </div>
              </div>

              {salarie && (
                <UserInfos
                  imgProfile={imgProfile}
                  clientName={salarie.client.nom}
                  profil={profil.name}
                  name={salarie.fullname}
                />
              )}
            </div>
            <Nav links={nav.links}>{nav.children}</Nav>
            <Routes>
              <Route
                path="/document/*"
                element={<ListDocumentForOneSalarie salarieId={salarieId} />}
              />
              <Route path="/dashboard" element={<DashBoardMain />} />
              <Route
                path="/profil"
                element={<Profil salarieId={salarieId} />}
              />
              <Route path="/:id/folder/*" element={<Folder />} />
              <Route
                path="/:salarieId/folder/:id/files/*"
                element={<ListFile />}
              />
              <Route path="/*" element={<div>Erreur</div>} />
            </Routes>
          </div>
        </navContext.Provider>
      </div>
      {isLoading && <Loader loadingMsg="Chargement..." />}
    </Fragment>
  );
};

export default Salaries;
